function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 42,
  cy: 42,
  r: 42,
  fill: "#fff"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.667 70v-7.051h-2.334V70h-4.666v-7.051H21.072L22.24 56h2.518C26.819 56 28 54.014 28 52.017V31.276C28 29.332 26.868 28 24.815 28H21v-7h11.667v-7h4.666v7h2.334v-7h4.666v7.124c10.069.34 14.056 4.155 15.2 8.458 1.353 5.087-2 9.357-4.884 10.397 3.502.892 8.351 3.48 8.351 9.45C63 57.556 56.728 63 44.333 63v7h-4.666zm-2.334-25.68V56c9.261 0 15.606-.875 15.606-5.87 0-5.358-6.856-5.81-15.606-5.81zm0-4.653c5.16 0 13.016-.364 13.016-5.834C50.349 29.167 45.5 28 37.333 28v11.667z",
  fill: "#FFBE0B"
});

var SvgBitcoin = function SvgBitcoin(props) {
  return React.createElement("svg", _extends({
    width: 84,
    height: 84,
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODQiIGhlaWdodD0iODQiIHZpZXdCb3g9IjAgMCA4NCA4NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNDIiIGN5PSI0MiIgcj0iNDIiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0zOS42NjY3IDcwVjYyLjk0ODdIMzcuMzMzM1Y3MEgzMi42NjY3VjYyLjk0ODdIMjEuMDcyM0wyMi4yMzkgNTZIMjQuNzU2N0MyNi44MTkzIDU2IDI4IDU0LjAxNDMgMjggNTIuMDE3VjMxLjI3NkMyOCAyOS4zMzIzIDI2Ljg2ODMgMjggMjQuODE1IDI4SDIxVjIxSDMyLjY2NjdWMTRIMzcuMzMzM1YyMUgzOS42NjY3VjE0SDQ0LjMzMzNWMjEuMTIzN0M1NC40MDE3IDIxLjQ2NDMgNTguMzg5MyAyNS4yNzkzIDU5LjUzMjcgMjkuNTgyQzYwLjg4NiAzNC42Njg3IDU3LjUzMyAzOC45Mzg3IDU0LjY0OSAzOS45NzkzQzU4LjE1MTMgNDAuODcwNyA2MyA0My40NTgzIDYzIDQ5LjQyOTNDNjMgNTcuNTU2MyA1Ni43MjggNjMgNDQuMzMzMyA2M1Y3MEgzOS42NjY3Wk0zNy4zMzMzIDQ0LjMxOTNWNTZDNDYuNTk0MyA1NiA1Mi45Mzg3IDU1LjEyNSA1Mi45Mzg3IDUwLjEyOTNDNTIuOTM4NyA0NC43NzIgNDYuMDgzMyA0NC4zMTkzIDM3LjMzMzMgNDQuMzE5M1pNMzcuMzMzMyAzOS42NjY3QzQyLjQ5MjMgMzkuNjY2NyA1MC4zNDg3IDM5LjMwMjcgNTAuMzQ4NyAzMy44MzMzQzUwLjM0ODcgMjkuMTY2NyA0NS41IDI4IDM3LjMzMzMgMjhWMzkuNjY2N1oiIGZpbGw9IiNGRkJFMEIiLz4KPC9zdmc+Cg==";
export { SvgBitcoin as ReactComponent };